import { useQuery } from "@tanstack/react-query";

import type { components } from "@/shared/api";

import { paymentQueryOptions } from "./paymentQueryOptions";

type PaymentStatus = components["schemas"]["PaymentOut"]["status"];

// Пока платёж не завершён, экран ждёт: событие `billing.updated` перечитывает его сразу,
// а без WebSocket — опрос раз в 3 секунды (frontend/rules.md, «Реальное время»).
const WAITING: readonly PaymentStatus[] = ["creating", "awaiting_payment"];
const POLL_MS = 3000;

export const usePayment = (paymentId: string | null) =>
  useQuery({
    ...paymentQueryOptions(paymentId ?? ""),
    enabled: paymentId !== null,
    refetchInterval: (query) =>
      query.state.data !== undefined && WAITING.includes(query.state.data.status) ? POLL_MS : false,
  });
